import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  collection,
  getDocs,
  orderBy,
  query
} from "firebase/firestore";

import { db } from "../firebase";
import AdminLayout from "../pages/admin/AdminLayout";
import "../pages/admin/AdminCommentReports.css";

function formatWhen(ts) {
  if (!ts) return "—";
  const date = ts.toDate ? ts.toDate() : new Date(ts);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-CA", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

function typeLabel(report) {
  const raw = report.type || report.targetType || "";
  if (!raw) return "General";
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}

export default function AdminReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadReports = async () => {
      try {
        const snapshot = await getDocs(
          query(collection(db, "reports"), orderBy("createdAt", "desc"))
        );
        setReports(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error("Load reports error:", err);
        setError(err.message || "Could not load reports.");
      } finally {
        setLoading(false);
      }
    };

    loadReports();
  }, []);

  return (
    <AdminLayout>
      <div className="admin-comment-reports">
        <div className="admin-cr-head">
          <div>
            <p className="admin-cr-eyebrow">Moderation</p>
            <h1>Content reports</h1>
            <p className="admin-cr-sub">
              Drops and other content flagged by members. Separate from comment reports.
            </p>
          </div>
        </div>

        {error && <div className="admin-cr-error">{error}</div>}

        {loading ? (
          <div className="admin-cr-empty">Loading reports…</div>
        ) : reports.length === 0 ? (
          <div className="admin-cr-empty">No content reports.</div>
        ) : (
          <div className="admin-cr-list">
            {reports.map((report) => (
              <article key={report.id} className="admin-cr-card">
                <div className="admin-cr-card-top">
                  <span className="admin-cr-pill">{typeLabel(report)}</span>
                  <span className="admin-cr-pill muted">{report.reason || "Unknown"}</span>
                  <span className="admin-cr-when">{formatWhen(report.createdAt)}</span>
                </div>
                <p className="admin-cr-preview">
                  {report.details || "No details provided."}
                </p>
                <div className="admin-cr-meta">
                  {report.targetType === "drop" && report.targetId ? (
                    <Link to={`/drop/${report.targetId}`}>Open drop ↗</Link>
                  ) : (
                    <span>{report.targetType || "target"} · {report.targetId || "—"}</span>
                  )}
                  <span>Creator · {report.targetUsername || "Unknown"}</span>
                  <span>Reporter · {report.reporterId || "—"}</span>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
